/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wsc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only if you enable 'Remove blank lines', which drops empty lines. Other options affect spaces and tabs within and around lines, not the number of newlines.`)
};

const es_wsc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo si activas 'Eliminar líneas en blanco', que descarta líneas vacías. Otras opciones afectan espacios y tabulaciones dentro y alrededor de líneas, no la cantidad de saltos de línea.`)
};

const de_wsc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur wenn Sie 'Leerzeilen entfernen' aktivieren, wodurch leere Zeilen entfernt werden. Andere Optionen wirken sich auf Leerzeichen und Tabulatoren innerhalb und um Zeilen aus, nicht auf die Anzahl der Zeilenumbrüche.`)
};

const nl_wsc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen als u 'Lege regels verwijderen' inschakelt, wat lege regels verwijdert. Andere opties beïnvloeden spaties en tabs binnen en rond regels, niet het aantal regelseinden.`)
};

const fr_wsc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seulement si vous activez « Supprimer les lignes vides », qui élimine les lignes vides. Les autres options affectent les espaces et les tabulations à l'intérieur et autour des lignes, pas le nombre de sauts de ligne.`)
};

const it_wsc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo se abiliti 'Rimuovi righe vuote', che elimina le righe vuote. Altre opzioni influenzano gli spazi e le tabulazioni all'interno e intorno alle righe, non il numero di interruzioni di riga.`)
};

const pt_br2_wsc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas se você habilitar 'Remover linhas em branco', que descarta linhas vazias. Outras opções afetam espaços e abas dentro e ao redor de linhas, não o número de quebras de linha.`)
};

const pt_wsc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas se ativar "Remover linhas em branco", que remove linhas vazias. Outras opções afetam espaços e abas dentro e ao redor das linhas, não o número de quebras de linha.`)
};

const ja_wsc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「空白行を削除」を有効にした場合のみで、空行がドロップされます。他のオプションは行内および行周辺のスペースとタブに影響しますが、改行の数には影響しません。`)
};

const zh_wsc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只有在您启用“删除空行”时才会，该选项会删除空行。其他选项只影响行内和行周围的空格与制表符，不会改变换行符的数量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wsc_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wsc_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wsc_faq2_a", locale)
	if (locale === "en") return en_wsc_faq2_a(inputs)
	if (locale === "es") return es_wsc_faq2_a(inputs)
	if (locale === "de") return de_wsc_faq2_a(inputs)
	if (locale === "nl") return nl_wsc_faq2_a(inputs)
	if (locale === "fr") return fr_wsc_faq2_a(inputs)
	if (locale === "it") return it_wsc_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_wsc_faq2_a(inputs)
	if (locale === "pt") return pt_wsc_faq2_a(inputs)
	if (locale === "ja") return ja_wsc_faq2_a(inputs)
	return zh_wsc_faq2_a(inputs)
};